var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Facebook"),React.createElement("g",{"id":"Header-&-Footer","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},React.createElement("g",{"id":"Footer:-1400","transform":"translate(-1175.000000, -548.000000)","stroke":"#1030AE","strokeWidth":"2"},React.createElement("g",{"id":"Bottom","transform":"translate(0.000000, 509.000000)"},React.createElement("g",{"id":"Social","transform":"translate(1176.000000, 40.500000)"},React.createElement("path",{"d":"M11,0 L8,0 C5.23857625,0 3,2.23857625 3,5 L3,8 L0,8 L0,12 L3,12 L3,20 L7,20 L7,12 L10,12 L11,8 L7,8 L7,5 C7,4.44771525 7.44771525,4 8,4 L11,4 L11,0 Z","id":"icon-facebook"})))))]);
}

Facebook.defaultProps = {"width":"13px","height":"23px","viewBox":"0 0 13 23","version":"1.1"};

module.exports = Facebook;

Facebook.default = Facebook;
